module.exports = __webpack_public_path__ + "03_mid_black.b07db562.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/03_mid_black.png
// module id = rfxa
// module chunks = 0